import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CaptchaAction, CaptchaService } from '../../../core/services';
import { ApiService } from '../../../core/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class HelpService {
    constructor(
        private apiService: ApiService,
        private readonly captcha: CaptchaService
    ) {}

    /**
     * The API rejects a support request without a valid CAPTCHA token, so one is taken
     * immediately before the call — tokens are single-use and expire after five minutes.
     */
    submitSupportRequest(supportRequestInfo: any): Observable<any> {
        return this.captcha.getToken(CaptchaAction.SupportRequest).pipe(
            switchMap((captchaToken) =>
                this.apiService.put(`/support`, {
                    ...supportRequestInfo,
                    captchaToken: captchaToken
                })
            )
        );
    }
}
